import { render } from "./Automations.vue?vue&type=template&id=0742437a"
import script from "./Automations.vue?vue&type=script&lang=js"
export * from "./Automations.vue?vue&type=script&lang=js"

import "./Automations.vue?vue&type=style&index=0&id=0742437a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__